const API_KEY = 'DYLPDQZQUGONAT0QUU3TLQIOSNFHM32HODTJ6GJ73U9UCXDZ6NMPY4BCSPSV8WB2PHJYX25NQ04YWIK9';
const SCRAPING_BEE_URL = 'https://app.scrapingbee.com/api/v1/';

export async function getWebsiteScreenshot(url: string): Promise<string> {
  const params = new URLSearchParams({
    api_key: API_KEY,
    url: url,
    screenshot: 'true',
    block_ads: 'true',
    screenshot_full_page: 'true'
  });

  try {
    const response = await fetch(`${SCRAPING_BEE_URL}?${params.toString()}`, {
      method: 'GET'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error('Error capturing screenshot:', error);
    throw new Error('Failed to capture website screenshot');
  }
}